import { DomainDependencies } from '../domaindependencies/types';
import { Hasher } from '../hasher';
import { HasDependencies, hashString } from '../types';
import {
  cleanupMetricTree,
  convertMetricTreeToMetricDetails,
} from '../utils-metrics';
import { MetricTree } from './types';

export interface MetricsService extends HasDependencies {
  getMetricTree: () => MetricTree;
}

export class BackendMetricsService implements MetricsService {
  constructor(readonly domainDependencies: DomainDependencies) {}

  public getDeps = () => [hashString([Hasher.hash(this.domainDependencies)])];

  public getMetricTree = (): MetricTree => {
    const metricTree = this.domainDependencies?.domainInfo?.metricTree;
    if (!metricTree) {
      throw new Error('metric tree cannot be null');
    }
    return convertMetricTreeToMetricDetails(cleanupMetricTree(metricTree));
  };
}
